import { hasUser } from "@shared/utils/users";
import { useSelector } from "react-redux";

export const useUser = () => {
  return useSelector(({ user }) => user.user);
};

export const useUserLobby = () => {
  return useSelector(({ user }) => user.user?.lobby);
};

export const useUserState = () => {
  return useSelector(({ user }) => user);
};

export const useUserError = () => {
  return useSelector(({ user }) => user.error);
};
export const useUserBankGroup = () => {
  return useSelector(({ user }) => user.user?.bankGroup);
};

export const useIsAuth = () => {
  return useSelector(({ user }) => hasUser(user));
};
